import { requestAsync, httpMethods } from 'redux-query';
import cfg from 'cfg';
import auth from 'dash-front/auth';

export const createSocialCampaign = body =>
    requestAsync({
        url: `${cfg.dash.api.host}/api/media/social-campaigns?access_token=${auth.getAccessToken()}`,
        body,
        force: true,
        options: {
            method: httpMethods.POST
        },
        transform: item => ({
            socialCampaigns: item
        }),
        update: {
            socialCampaigns: (prev = [], item) => prev.concat(item)
        }
    });

export const getSocialCampaigns = () =>
    requestAsync({
        url: `${cfg.dash.api.host}/api/media/social-campaigns?access_token=${auth.getAccessToken()}`,
        force: true,
        transform: items => ({
            socialCampaigns: items
        }),
        update: {
            socialCampaigns: (prev = [], next) => next
        }
    });



/** WEBPACK FOOTER **
 ** ../src/dash/front/actions/social-campaigns.js
 **/